import Box from '@mui/material/Box';

export const GovernanceTab = () => {
  return <Box>Governance</Box>;
};
